var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return this.$props.supplier
    ? _c("section", { staticClass: "atmo-content-group" }, [
        _c("h6", [_vm._v("Информация о поставщике")]),
        _c(
          "ul",
          {
            staticClass: "atmo-content-block-2-columns atmo-no-item-separator",
          },
          [
            _c("li", [
              _c("dt", [_vm._v("Наименование:")]),
              _c("dd", {
                domProps: { textContent: _vm._s(this.$props.supplier.title) },
              }),
            ]),
            _c("li", [
              _c("dt", [_vm._v("ИНН:")]),
              _c("dd", {
                domProps: { textContent: _vm._s(this.$props.supplier.inn) },
              }),
            ]),
            this.$props.supplier.kpp
              ? _c("li", [
                  _c("dt", [_vm._v("КПП:")]),
                  _c("dd", {
                    domProps: { textContent: _vm._s(this.$props.supplier.kpp) },
                  }),
                ])
              : _vm._e(),
            _c("li", [
              _c("dt", [_vm._v("Адрес:")]),
              _c("dd", {
                domProps: { textContent: _vm._s(this.$props.supplier.address) },
              }),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }